// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems } from './shared';

export const label = 'Buildings & Contents - Evan';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B12/4639155',
  policyDetailsId: '123441237882',
  coverType: 'Buildings & Contents',
  productDescription: 'Evan',
  accidentalDamageLevel: { Buildings: 'Basic', Contents: 'Full' },
  specifiedItems: mockSpecifiedItems
});
